import ApiRequest from "../../utils/api-request";

const state = {
    settings: {},
    contactInfo: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        address: {
            firstLine: '',
            secondLine: '',
            city: '',
            country: '',
            state: '',
            zipCode: '',
        },
        address2: {
            firstLine: '',
            zipCode: ''
        }
    },
    locations: [],
    bikes: [],
    eventBikes: [],
    bikesNotLocation: [],
    types: [],
    tours: [],
    events: [],
    eventLocations: [],
    eventDates: [],
    currentEventId: 0,
    products: [],
    attractions: [],
    timeOptions: [],
    targetDate: '',
    dateNumber: +(new Date())
}

const actions = {
    init: (context) => {
        new ApiRequest().getLocation().then((response) => {
            return context.commit('SET_SETTINGS', {
                googleMapsApiKey: window.application.googleMapsApiKey,
                location: response.data,
                altLocations: window.application.altLocations,
                apiURL: window.application.apiURL,
                email: window.application.email,
                generalEnquiriesPhoneNumber: window.application.generalEnquiriesPhoneNumber,
                instagramAccountLink: window.application.instagramAccountLink
            })
        });
    },
    fetchLocations: (context) => {
        return new ApiRequest().getLocations().then((response) => {
            context.commit('SET_LOCATIONS', response.data.data);
        });
    },
    fetchBikes: (context) => {
        return new ApiRequest().getBikes().then((response) => {
            context.commit('SET_BIKES', response.data.bikes);
        });
    },
    fetchBikesNotLocation: (context) => {
        return new ApiRequest().getBikesNotLocation().then((response) => {
            context.commit('SET_BIKES_NOT_LOCATION', response.data.bikes);
        });
    },
    fetchTypes: (context) => {
        return new ApiRequest().getTypes().then((response) => {
            context.commit('SET_TYPES', response.data.types);
            context.commit('SET_DATE_NUMBER')
        });
    },
    fetchEventBikes: (context, slug) => {

        return new ApiRequest().getEventBySlug(slug).then((response) => {

            if(response.data.event && response.data.event.id !== undefined) {
                context.commit('SET_CURRENT_EVENT_ID', response.data.event.id);
            }

            if(response.data.event && response.data.event.event_locations !== undefined) {
                context.commit('SET_EVENT_LOCATIONS', response.data.event.event_locations.map(locationItem => locationItem.location_id))
            }

            if(response.data.event && response.data.event.dates !== undefined) {
                context.commit('SET_EVENT_DATES', response.data.event.dates)
            }

            context.commit('SET_EVENT_BIKES', response.data.bikes);
        });
    },
    fetchTours: (context) => {
        return new ApiRequest().getTours().then((response) => {
            context.commit('SET_TOURS', response.data.tours);
        });
    },
    fetchEvents: (context) => {
        return new ApiRequest().getEvents().then((response) => {
            context.commit('SET_EVENTS', response.data.events);
        });
    },
    fetchProducts: (context) => {
        return new ApiRequest().getProducts().then((response) => {
            context.commit('SET_PRODUCTS', response.data.products);
        });
    },
    fetchAttractions: (context) => {
        return new ApiRequest().getAttractions().then((response) => {
            context.commit('SET_ATTRACTIONS', response.data.data);
        });
    },
    fetchTimeOptions: (context) => {
        return new ApiRequest().getTimeOptions().then((response) => {
            context.commit('SET_TIME_OPTIONS', response.data.time_options);
            // context.commit('filter/SET_DURATION', response.data.time_options[0], { root: true });
        });
    },
    storeUserLocation: (context, data) => {
        return new ApiRequest().setUserLocation(data).then((response) => {
            return response;
        })
    },

    sendContacts: (context, data) => {
        return new ApiRequest().sendContacts(data).then((response) => {
            return response;
        })
    }
}

const mutations = {
    SET_SETTINGS: (state, value) => {
        state.settings = value;
    },
    SET_FIRST_NAME: (state, value) => {
        state.contactInfo.firstName = value;
    },
    SET_LAST_NAME: (state, value) => {
        state.contactInfo.lastName = value;
    },
    SET_EMAIL: (state, value) => {
        state.contactInfo.email = value;
    },
    SET_PHONE: (state, value) => {
        state.contactInfo.phone = value;
    },
    SET_ADDRESS: (state, value) => {
        state.contactInfo.address = value;
    },
    SET_ADDRESS2: (state, value) => {
        state.contactInfo.address2 = value;
    },
    SET_LOCATIONS: (state, value) => {
        state.locations = value;
    },
    SET_BIKES: (state, value) => {
        state.bikes = value;
    },
    SET_BIKES_NOT_LOCATION: (state, value) => {
        state.bikesNotLocation = value;
    },
    SET_TYPES: (state, value) => {
        state.types = value;
    },
    SET_TOURS: (state, value) => {
        state.tours = value;
    },
    SET_EVENTS: (state, value) => {
        state.events = value;
    },
    SET_EVENT_BIKES: (state, value) => {
        state.eventBikes = value;
    },
    SET_EVENT_LOCATIONS: (state, value) => {
        state.eventLocations = value;
    },
    SET_CURRENT_EVENT_ID: (state, value) => {
        state.currentEventId = value;
    },
    SET_EVENT_DATES: (state, value) => {
        state.eventDates = value;
    },
    SET_PRODUCTS: (state, value) => {
        state.products = value;
    },
    SET_ATTRACTIONS: (state, value) => {
        state.attractions = value;
    },
    SET_TIME_OPTIONS: (state, value) => {
        state.timeOptions = value;
    },
    SET_TARGET_DATE: (state, value) => {
        state.targetDate = value;
    },
    SET_DATE_NUMBER: (state) => {
        state.dateNumber = +(new Date());
    }
}

const getters = {
    dateNumber: (state) => state.dateNumber,
    settings: (state) => state.settings,
    firstName: (state) => state.contactInfo.firstName,
    lastName: (state) => state.contactInfo.lastName,
    email: (state) => state.contactInfo.email,
    phone: (state) => state.contactInfo.phone,
    address: (state) => state.contactInfo.address,
    address2: (state) => state.contactInfo.address2,
    locations: (state) => state.locations,
    paypalClientId: (state) => !!state.settings.location.br_paypal_client_id ? state.settings.location.br_paypal_client_id : '',
    stripeKey: (state) => !!state.settings.location.stripe_key ? state.settings.location.stripe_key : '',
    googlePayData: (state) => {
        return {
            gatewayMerchantId: !!state.settings.location.gatewayMerchantId ? state.settings.location.gatewayMerchantId : '',
            gateway: !!state.settings.location.gateway ? state.settings.location.gateway : '',
            merchantId: !!state.settings.location.merchantId ? state.settings.location.merchantId : '',
            merchantName: !!state.settings.location.merchantName ? state.settings.location.merchantName : '',
            environment: !!state.settings.location.environment ? state.settings.location.environment : '',
        }
    },
    bikes: (state) => state.bikes,
    bikesNotLocation: (state) => state.bikesNotLocation,
    types: (state) => state.types,
    tours: (state)  => {
        const specialToursTag = window.application.specialToursTag || '';
        if(specialToursTag) {
            return state.tours.filter(tour => {
                // parsing tags
                let tags = JSON.parse(tour.tags);
                if(!tags.includes(specialToursTag)) {
                    return tour;
                }
            });
        }
        return state.tours
    },
    specialTours: (state) => {
        const specialToursTag = window.application.specialToursTag || '';
        if(specialToursTag) {
            return state.tours.filter(tour => {
                // parsing tags
                let tags = JSON.parse(tour.tags);
                if(tags.includes(specialToursTag)) {
                    return tour;
                }
            });
        }
        return []
    },
    events: (state) => state.events,
    eventBikes: (state) => state.eventBikes,
    eventLocations: (state) => state.eventLocations,
    eventDates: (state) => state.eventDates,
    currentEventId: (state) => state.currentEventId,
    products: (state) => state.products,
    attractions: (state) => state.attractions,
    bikeTypes: (state) => {         // potentially unnecessary getter (filter by bike's type was removed)
        return state.bikes.map(item => ({
            id: item.type_id,
            name: item.type_name,
            disabled: false
        }))
    },
    timeOptions: (state) => state.timeOptions,

    targetDate: (state) => state.targetDate
}

export default {
    strict: true,
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
